<template>
  <div class="pre-map mx-auto">
    <SelectBox
      v-for="(item, key) of prefectureList"
      :key="'prefecture-' + key"
      :id="'pre-' + item.code_id"
      v-model="prefecture"
      :value="item.code_id"
      class="pre-box"
      @click="setPrefectureCode(item.code_id)"
    >
      <span class="w6 text-sm">{{
        item.code_id === '1' ? item.code_name : $subString(item.code_name)
      }}</span>
    </SelectBox>
  </div>
</template>

<script setup>
// eslint-disable-next-line
import { computed, defineProps, defineEmits, inject } from 'vue';
import { MY_PREFECTURE, COOKIE_EXPIRE } from '@/constants/common';
import { useStore } from 'vuex';
import useDataCookie from '@/uses/useDataCookie';

const props = defineProps({
  modelValue: String,
});
const { setPrefectureCode } = useDataCookie();
const store = useStore();
const emit = defineEmits(['update:modelValue']);
const $cookie = inject('$cookie');
const $subString = inject('$subString');

const prefectureList = computed(() => {
  const data = store.getters['common/prefectureCategories'];
  return data.map((item) => {
    item.selected = false;

    return item;
  });
});

const prefecture = computed({
  get() {
    return props.modelValue;
  },
  set(newPrefecture) {
    emit('update:modelValue', newPrefecture);
  },
});
</script>
